import React, { ChangeEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Button,
    CardMedia,
    IconButton,
    Input,
    MenuItem,
    Select,
    SelectChangeEvent,
    TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const AddDispatcher = () => {
    const navigate = useNavigate();

    const [image, setImage] = useState<string>("");
    const [fileName, setFileName] = useState<string>("");

    const [country, setCountry] = useState("default");
    const [state, setState] = useState("default");
    const [city, setCity] = useState("default");

    const handleCountryChange = (event: SelectChangeEvent) => {
        setCountry(event.target.value as string);
    };

    const handleStateChange = (event: SelectChangeEvent) => {
        setState(event.target.value as string);
    };

    const handleCityChange = (event: SelectChangeEvent) => {
        setCity(event.target.value as string);
    };

    return (
        <>
            <div className="main_title">
                <h1>Add Dispatcher</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                    <button onClick={() => navigate("/manage-dispatcher")}>
                        Manage Dispatchers
                    </button>{" "}
                    - Add Dispatcher
                </p>
            </div>

            <div className="cards">
                <div className="form">
                    <div className="gap_p">

                        {/* Profile Image */}
                        <div className="control_group w_100">
                            <div className="gap_p">

                        <div className="control_group w_33">
                            <label htmlFor="icon-button-file">Profile Image*</label>
                            {image ? (
                                <div className="upload_image">
                                    <div className="upload_image_holder">
                                        <figure>
                                            <CardMedia
                                                component="img"
                                                image={image}
                                                alt="Uploaded profile photo"
                                            />
                                        </figure>
                                        <IconButton
                                            aria-label="Remove uploaded image"
                                            onClick={() => {
                                                setImage("");
                                                setFileName("");
                                            }}
                                            size="small"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                    </div>
                                </div>
                            ) : (
                                <label
                                    className="upload_image"
                                    htmlFor="icon-button-file"
                                >
                                    <Input
                                        sx={{ display: "none" }}
                                        id="icon-button-file"
                                        type="file"
                                        inputProps={{ accept: "image/png,image/jpeg" }}
                                        onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                            const files = (event.target as HTMLInputElement).files;
                                            if (files && files[0].type.includes("image")) {
                                                setFileName(files[0].name);
                                                setImage(URL.createObjectURL(files[0]));
                                            }
                                        }}
                                    />
                                    <span className="upload_image_holder">
                                        <figure className="add_img">
                                            <img
                                                src="/static/images/user_placeholder.png"
                                                alt="placeholder"
                                            />
                                            <span className="upload_img_icon">
                                                <img
                                                    src="/static/images/edit2_icon.svg"
                                                    alt="Upload"
                                                />
                                            </span>
                                        </figure>
                                    </span>
                                </label>
                            )}
                        </div>
                            </div>
                        </div>

                        {/* Name */}
                        <div className="control_group w_33">
                            <label htmlFor="name">Name*</label>
                            <TextField id="name" placeholder="Enter Name" fullWidth />
                        </div>

                        {/* Email */}
                        <div className="control_group w_33">
                            <label htmlFor="email">Email*</label>
                            <TextField id="email" placeholder="Enter Email" type="email" fullWidth />
                        </div>

                        {/* Phone */}
                        <div className="control_group w_33">
                            <label htmlFor="phone">Phone Number*</label>
                            <TextField id="phone" placeholder="Enter Phone Number" fullWidth />
                        </div>

                        {/* Address */}
                        <div className="control_group w_100">
                            <label htmlFor="address">Address*</label>
                            <TextField id="address" placeholder="Enter Address" fullWidth />
                        </div>

                        {/* Country */}
                        <div className="control_group w_33">
                            <label htmlFor="country">Country*</label>
                            <Select
                                id="country"
                                fullWidth
                                value={country}
                                onChange={handleCountryChange}
                            >
                                <MenuItem disabled value="default">Select Country</MenuItem>
                                <MenuItem value="India">India</MenuItem>
                                <MenuItem value="USA">USA</MenuItem>
                                <MenuItem value="UK">UK</MenuItem>
                            </Select>
                        </div>

                        {/* State */}
                        <div className="control_group w_33">
                            <label htmlFor="state">State*</label>
                            <Select
                                id="state"
                                fullWidth
                                value={state}
                                onChange={handleStateChange}
                            >
                                <MenuItem disabled value="default">Select State</MenuItem>
                                <MenuItem value="Delhi">Delhi</MenuItem>
                                <MenuItem value="Maharashtra">Maharashtra</MenuItem>
                                <MenuItem value="California">California</MenuItem>
                            </Select>
                        </div>

                        {/* City */}
                        <div className="control_group w_33">
                            <label htmlFor="city">City*</label>
                            <Select
                                id="city"
                                fullWidth
                                value={city}
                                onChange={handleCityChange}
                            >
                                <MenuItem disabled value="default">Select City</MenuItem>
                                <MenuItem value="New Delhi">New Delhi</MenuItem>
                                <MenuItem value="Mumbai">Mumbai</MenuItem>
                                <MenuItem value="San Francisco">San Francisco</MenuItem>
                            </Select>
                        </div>

                        {/* Pin Code */}
                        <div className="control_group w_33">
                            <label htmlFor="pin">Pin Code*</label>
                            <TextField id="pin" placeholder="Enter Pin" fullWidth />
                        </div>

                    </div>

                    {/* Submit Button */}
                    <div className="form_btn">
                        <Button className="btn btn_primary">Save</Button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddDispatcher;
